import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-widget-pyramide-ages',
    templateUrl: './pyramide-ages.component.html',
    styleUrls: ['./pyramide-ages.component.scss']
})
export class PyramideAgesComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();

    echartsIntance = null;

    secteur = '';
    iris = '';

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService) {
    }

    options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: params => {
                var lib = '';
                params.forEach(d => {
                    lib += d.seriesName + ' : ' + Math.round(d.data).toLocaleString('fr-FR') + ' %<br/>';
                });
                return lib;
            }
        },
        legend: {
            orient: 'vertical',
            right: '10px',
            align: 'right',
            data: [],
        },
        grid: {
            left: '1%',
            right: '3%',
            top: '0',
            bottom: '15',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLabel: {},
        },
        yAxis: {
            type: 'category',
            data: ['0-14 ans', '15-29 ans', '30-44 ans', '45-59 ans', '60-74 ans', '75 ans et +']
        },
        color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#9C9C9C', '#FF5455'],
        series: []
    };

    data = null;

    ngOnInit() {
        if (this.deviceService.isMobile()) {
            this.options.legend = {
                orient: 'horizontal',
                right: 'auto',
                align: 'auto',
                data: [],
            };
            this.options.grid.top = '50px';
            this.options.grid.left = '0px';
            this.options.grid.right = '0px';
        }

        this.initData();
        this.extChange.subscribe(data => {
            this.initData();
        });
    }

    initData() {
        this.iris = this.favorite.iris;
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
        }
        this.setData();
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    setData() {
        this.options.legend.data[0] = this.favorite.ad_city.name;

        const total = this.favorite.ad_city.carac_commune.P75P +
            this.favorite.ad_city.carac_commune.P6074 +
            this.favorite.ad_city.carac_commune.P4559 +
            this.favorite.ad_city.carac_commune.P3044 +
            this.favorite.ad_city.carac_commune.P1529 +
            this.favorite.ad_city.carac_commune.P0014;

        const total_fr = this.favorite.ad_city.carac_commune_fr.P75P +
            this.favorite.ad_city.carac_commune_fr.P6074 +
            this.favorite.ad_city.carac_commune_fr.P4559 +
            this.favorite.ad_city.carac_commune_fr.P3044 +
            this.favorite.ad_city.carac_commune_fr.P1529 +
            this.favorite.ad_city.carac_commune_fr.P0014;

        this.options.legend.data = [this.favorite.ad_city.name, 'France'];

        this.data = {
            series: [
                {
                    name: this.favorite.ad_city.name,
                    type: 'bar',
                    data: [
                        Math.round(this.favorite.ad_city.carac_commune.P0014 / total * 100),
                        Math.round(this.favorite.ad_city.carac_commune.P1529 / total * 100),
                        Math.round(this.favorite.ad_city.carac_commune.P3044 / total * 100),
                        Math.round(this.favorite.ad_city.carac_commune.P4559 / total * 100),
                        Math.round(this.favorite.ad_city.carac_commune.P6074 / total * 100),
                        Math.round(this.favorite.ad_city.carac_commune.P75P / total * 100),
                    ]
                },
                {
                    name: 'France',
                    type: 'bar',
                    data: [
                        Math.round(this.favorite.ad_city.carac_commune_fr.P0014 / total_fr * 100),
                        Math.round(this.favorite.ad_city.carac_commune_fr.P1529 / total_fr * 100),
                        Math.round(this.favorite.ad_city.carac_commune_fr.P3044 / total_fr * 100),
                        Math.round(this.favorite.ad_city.carac_commune_fr.P4559 / total_fr * 100),
                        Math.round(this.favorite.ad_city.carac_commune_fr.P6074 / total_fr * 100),
                        Math.round(this.favorite.ad_city.carac_commune_fr.P75P / total_fr * 100),
                    ]
                }
            ]
        };

        if (this.iris.length == 7) {
            this.options.legend.data = [this.favorite.ad_city.name, 'Secteur "' + this.cityService.getQuartierName('_gq', this.favorite.ad_city, this.iris) + '"', 'France'];

            const total_q = this.favorite.ad_city.carac_commune_gq[this.iris].P75P +
                this.favorite.ad_city.carac_commune_gq[this.iris].P6074 +
                this.favorite.ad_city.carac_commune_gq[this.iris].P4559 +
                this.favorite.ad_city.carac_commune_gq[this.iris].P3044 +
                this.favorite.ad_city.carac_commune_gq[this.iris].P1529 +
                this.favorite.ad_city.carac_commune_gq[this.iris].P0014;

            this.data.series = [
                this.data.series[0],
                {
                    name: 'Secteur "' + this.cityService.getQuartierName('_gq', this.favorite.ad_city, this.iris) + '"',
                    type: 'bar',
                    data: [
                        Math.round(this.favorite.ad_city.carac_commune_gq[this.iris].P0014 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_gq[this.iris].P1529 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_gq[this.iris].P3044 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_gq[this.iris].P4559 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_gq[this.iris].P6074 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_gq[this.iris].P75P / total_q * 100),
                    ]
                }, this.data.series[1]];
        }
        if (this.iris.length > 7) {
            this.options.legend.data = [this.favorite.ad_city.name, 'Quartier "' + this.cityService.getQuartierName('_iris', this.favorite.ad_city, this.iris) + '"', 'France'];

            const total_q = this.favorite.ad_city.carac_commune_iris[this.iris].P75P +
                this.favorite.ad_city.carac_commune_iris[this.iris].P6074 +
                this.favorite.ad_city.carac_commune_iris[this.iris].P4559 +
                this.favorite.ad_city.carac_commune_iris[this.iris].P3044 +
                this.favorite.ad_city.carac_commune_iris[this.iris].P1529 +
                this.favorite.ad_city.carac_commune_iris[this.iris].P0014;

            this.data.series = [
                this.data.series[0],
                {
                    name: 'Quartier "' + this.cityService.getQuartierName('_iris', this.favorite.ad_city, this.iris) + '"',
                    type: 'bar',
                    data: [
                        Math.round(this.favorite.ad_city.carac_commune_iris[this.iris].P0014 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_iris[this.iris].P1529 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_iris[this.iris].P3044 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_iris[this.iris].P4559 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_iris[this.iris].P6074 / total_q * 100),
                        Math.round(this.favorite.ad_city.carac_commune_iris[this.iris].P75P / total_q * 100),
                    ]
                }, this.data.series[1]];
        }

        if (this.echartsIntance) {
            this.echartsIntance.setOption(this.options);
        }
    }

    onChartInit(ec) {
        this.echartsIntance = ec;
    }
}
